import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useSearchParams } from "react-router-dom";
// function ProductsList() {
//     const [data, setData] = useState([]);
//     useEffect(() => {
//         GetProductList();
//     }, []);

//     function GetProductList() {
//         Swal.fire({
//             title: "Loading...",
//             html: `
//                 <div class="custom-loading-container">
//                     <div class="custom-spinner"></div>
//                     <p>Please wait...</p>
//                 </div>
//             `,
//             showConfirmButton: false,
//             background: "rgba(0, 0, 0, 0.8)",
//             customClass: {
//               popup: 'custom-popup',
//               title: 'custom-title',
//               htmlContainer: 'custom-html-container'
//             }
//           });
//         fetch(`https://api.domehelp.com/ProductInformation/GetAllProducts`, {
//             method: "POST",
//         })
//             .then((response) => {
//                 if (!response.ok) {
//                     Swal.fire("Warning!", "getting Error.", "warning");
//                     return false;
//                 }
//                 return response.json();
//             })
//             .then((result) => {
//                 if (result.status === 1) {
//                     setData(result.data);
//                     Swal.close();
//                 } else {
//                     setData([]);
//                 }
//             })
//             .catch((error) => {
//                 Swal.fire("Warning!", error.toString(), "warning");
//             });
//     }

//     return (
//         <>
//             <div className="container">
//                 <div className="row mt-4 mb-4">
//                     {data.map((item, index) => (
//                         <div className="col-4" key={index + 1}>
//                             <div className="card" style={{ width: "100%", borderRadius: 0, border: "none", boxShadow: "none" }}>
//                                 <Link to={`/ProductDeatils/${item.productId}`}><img src={`https://api.domehelp.com/ProductDoc/${item.pBannerImage}`}  className="card-img-top" alt="..." style={{ borderRadius: 0, position: "relative"}} /></Link>
//                                 <div className="discount-icons">{item.discount}%</div>
//                                 <div className="card-body" style={{ padding: 10 }}>
//                                     <Link to={`/ProductDeatils/${item.productId}`} style={{ fontSize: 16 }}>{item.productName}</Link>
//                                     <h6 style={{ fontSize: 18 }}><span><del aria-hidden="true">₹{item.pPreviousAmount}</del> <span>₹{item.pCurrentAmount}</span></span></h6>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </>
//     );
// }

export default function ProductsList() {
  const [parentCategories, setParentCategories] = useState([
    { typeID: 0, typeName: "All" },
  ]);
  const [searchParams] = useSearchParams();
  const catId = Number(searchParams.get("Cat")) || 0;

  const [subCategories, setSubCategories] = useState([]);

  const [selectedTypeID, setSelectedTypeID] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    GetCategories();
    setSelectedTypeID(catId);
  }, [catId]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [selectedTypeID]);

  function GetCategories() {
    fetch("https://api.domehelp.com/ProductInformation/GetJobWithJobTypes", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch categories.");
        }
        return response.json();
      })
      .then((result) => {
        if (result.status === 1) {
          setParentCategories([
            { typeID: 0, typeName: "All" },
            ...result.data.parentCategories,
          ]);

          setSubCategories(result.data.subCategories);
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  const filtered = useMemo(() => {
    return subCategories.filter(
      (x) =>
        (selectedTypeID === 0 || x.typeID === selectedTypeID) &&
        x.subCategoryName.toLowerCase().includes(search.toLowerCase()),
    );
  }, [subCategories, selectedTypeID, search]);

  const selected = parentCategories.find((x) => x.typeID === selectedTypeID);

  return (
    <section className="categories-page">
      <div className="container categories-container">
        <div className="row gx-4 gy-4">
          {/* Sidebar */}
          <div className="col-lg-3 col-xl-3">
            <div className="sidebar-card">
              <h5>Browse Categories</h5>

              {parentCategories.map((cat) => (
                <button
                  key={cat.typeID}
                  className={`parent-btn ${
                    selectedTypeID === cat.typeID ? "active" : ""
                  }`}
                  onClick={() => setSelectedTypeID(cat.typeID)}
                >
                  <i className="bi bi-folder-fill"></i>
                  <span>{cat.typeName}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Main Content */}
          <div className="col-lg-9 col-xl-9">
            <div className="top-bar">
              <div>
                <h3>{selected?.typeName}</h3>
                <p>Showing {filtered.length} Sub Categories</p>
              </div>

              <input
                className="search-box"
                placeholder="Search categories..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <div className="row g-4">
              {filtered.map((item) => (
                <div
                  className="col-xl-3 col-lg-4 col-md-6"
                  key={item.subCategoryID}
                >
                  <Link
                    to={`/ProductDetails/${item.subCategoryID}`}
                    className="text-decoration-none"
                  >
                    <div className="category-card">
                      {item.image ? (
                        <img
                          src={`https://api.domehelp.com/ProductDoc/${item.image}`}
                          alt={item.subCategoryName}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://api.iconify.design/mdi/database.svg";
                          }}
                        />
                      ) : (
                        <div className="category-placeholder">
                          <i className="bi bi-folder-fill"></i>
                        </div>
                      )}
                      <div className="category-body">
                        <h5>{item.subCategoryName}</h5>

                        <div className="explore">
                          <span>Explore Category</span>
                          <i className="bi bi-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
